(function () {
  var form = document.getElementById('VgWriteForUsForm');
  if (!form) return;
 
  // Honeypot: bots fill hidden fields, people never see them.
  form.addEventListener('submit', function (e) {
    var hp = form.querySelector('[data-vg-hp]');
    if (hp && hp.value.trim() !== '') {
      e.preventDefault();
    }
  });
 
  // Smooth scroll from the hero button to the pitch form.
  var cta = document.querySelector('.vg-wfu__cta[href="#VgPitch"]');
  var target = document.getElementById('VgPitch');
  if (cta && target) {
    cta.addEventListener('click', function (e) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var firstField = target.querySelector('input[name="contact[name]"]');
      if (firstField) {
        setTimeout(function () { firstField.focus({ preventScroll: true }); }, 400);
      }
    });
  }
})();